/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'remark': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M124.2 2.5h734.9v145.4H124.2zm604 176.7H255.1L52.3 562.3 69.4 575a2136.39 2136.39 0 01343 319.9c-6.1 12-9.8 25.4-9.8 39.9 0 49.2 39.9 89.1 89.1 89.1 49.2 0 89.1-39.9 89.1-89.1 0-14.4-3.7-27.8-9.8-39.9 101.3-117.9 216.1-225.3 343-320l17-12.7-202.8-383zM520.8 523.9V851c-9.2-3.2-18.9-5.3-29.1-5.3-10.3 0-20 2.1-29.2 5.3V523.9c-31.3-11.8-53.7-41.9-53.7-77.3 0-45.8 37.1-82.9 82.9-82.9 45.8 0 82.9 37.1 82.9 82.9-.1 35.4-22.4 65.5-53.8 77.3z" _fill="#333"/>'
  }
})
